class PlusKey extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.init();
	}
	init() {
		this.setup();
		this.interact();
	}

	setup() { 
		new MasterTimeline({ triggerInit: this, scrollTrigger: {
				trigger: this.querySelector('.plus-key-item.plus-key-item-touch'),
				start: 'top top+=80%',
			}, tweenArr: [
				new FadeIn({ el: this.querySelector('.plus-key-item-touch-title') }),
				new FadeIn({ el: this.querySelector('.plus-key-item-touch-img-next') }),
				new FadeIn({ el: this.querySelector('.plus-key-item-touch-img-hand') }),
		]})
		new MasterTimeline({ triggerInit: this, scrollTrigger: {
			trigger: this.querySelector('.plus-key-item.plus-key-item-marker'),
			start: 'top top+=80%',
		}, tweenArr: [
			new FadeIn({ el: this.querySelector('.plus-key-item-marker-img') }),
			new FadeSplitText({ el: this.querySelector('.plus-key-item-marker-title .txt') }),
			new FadeSplitText({ el: this.querySelector('.plus-key-item-marker-sub .txt') }),
			new FadeIn({ el: this.querySelector('.plus-key-item-marker-btn') }),
		]})
		new MasterTimeline({ triggerInit: this, scrollTrigger: {
			trigger: this.querySelector('.plus-key-item.plus-key-item-app'),
			start: 'top top+=80%',
		}, tweenArr: [
			new FadeIn({ el: this.querySelector('.plus-key-item-app-img-inner') }),
			new FadeSplitText({ el: this.querySelector('.plus-key-item-app-title .txt') }),
			new FadeIn({ el: this.querySelector('.plus-key-item-app-qr-img img') }),
			new FadeSplitText({ el: this.querySelector('.plus-key-item-app-qr-cap .txt') }),
		]})
		new MasterTimeline({ triggerInit: this, scrollTrigger: {
			trigger: this.querySelector('.plus-key-item.plus-key-item-queue'),
			start: 'top top+=80%',
		}, tweenArr: [
			new FadeSplitText({ el: this.querySelector('.plus-key-item-queue-title .txt') }),
			new FadeIn({ el: this.querySelector('.plus-key-item-queue-img') }),
		]})
	}
	interact() {

		const tlScrub = gsap.timeline({
            scrollTrigger: {
                trigger: this.querySelector('.plus-key-item.plus-key-item-touch'),
                start: 'top bottom',
                end: 'bottom top+=75%',
                scrub: 1,
            }
        })
        tlScrub
            .fromTo(this.querySelector('.plus-key-item-touch-img-next'), { xPercent: -10 }, { xPercent: 0, duration: 1, ease: 'none' }, 0)
            .fromTo(this.querySelector('.plus-key-item-touch-img-hand'), { xPercent: 10 }, { xPercent: 0, duration: 1, ease: 'none' }, 0)
            .fromTo(this.querySelector('.plus-key-item-touch-img-hand-cir'), { autoAlpha: 0 }, { autoAlpha: 1, duration: .4 }, .6);
	}
  
}

customElements.define("plus-key", PlusKey);
 